import { RouterProvider } from 'react-router-dom';
import { ConfigProvider } from 'antd-mobile';
import { router } from './routes';
import './App.css';

import { useEffect } from 'react';
import { authService } from '@/features/auth/services/authService';
import { STORAGE_KEYS } from '@/config/app.config';

function App() {
    useEffect(() => {
        const checkSession = async () => {
            const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
            if (token) {
                try {
                    await authService.getCurrentUser();
                } catch (error) {
                    console.error('Session verification failed:', error);
                    // Error is handled by interceptor (redirects to login)
                }
            }
        };

        checkSession();
    }, []);

    return (
        <ConfigProvider>
            <RouterProvider router={router} />
        </ConfigProvider>
    );
}

export default App;
